var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilewavybg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_23_1",
    "data-name": "Component 23 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 325.145,
    viewBox: "0 0 360 325.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(152 -16)",
    opacity: 0.059
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-152 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M348.584,1062.229S330.659,1021.178,368,999.091c26.393-16.826,75.476-30.371,94.872-45.375,24.823,53.946-25.611,74.654-73.084,90.722C350.372,1059.142,348.584,1062.229,348.584,1062.229Z",
    transform: "translate(-230.136 -845.196)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M328.728,1081.041s-17.925-41.052,19.419-63.144c26.393-16.827,75.476-30.371,94.872-45.375,24.823,53.952-25.611,74.654-73.09,90.727C330.516,1077.954,328.728,1081.041,328.728,1081.041Z",
    transform: "translate(-324.428 -755.895)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M368.448,1043.358s-17.925-41.052,19.419-63.145c26.393-16.826,75.476-30.371,94.866-45.375,24.823,53.953-25.611,74.654-73.084,90.727C370.236,1040.272,368.448,1043.358,368.448,1043.358Z",
    transform: "translate(-135.806 -934.839)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(164.866 86.559)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M372.815,1038.335s-14.608-33.458,15.826-51.457c21.506-13.711,61.506-24.749,77.315-36.982,20.23,43.967-20.874,60.839-59.563,73.94C374.275,1035.817,372.815,1038.335,372.815,1038.335Z",
    transform: "translate(-276.157 -949.896)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M356.611,1055.009s-14.608-33.452,15.826-51.457c21.506-13.711,61.506-24.748,77.309-36.976,20.23,43.967-20.868,60.839-59.557,73.935C358.065,1052.5,356.611,1055.009,356.611,1055.009Z",
    transform: "translate(-353.106 -870.686)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0.002 38.615)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M344.137,1029.994s-14.608-33.457,15.826-51.457c21.506-13.711,61.506-24.749,77.315-36.982,20.23,43.966-20.874,60.839-59.563,73.94C345.6,1027.477,344.137,1029.994,344.137,1029.994Z",
    transform: "translate(-247.479 -941.556)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M327.933,1046.669s-14.608-33.452,15.826-51.452c21.506-13.717,61.506-24.748,77.31-36.982,20.23,43.967-20.868,60.839-59.557,73.935C329.387,1044.157,327.933,1046.669,327.933,1046.669Z",
    transform: "translate(-324.428 -862.346)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M376.331,1013.634s-8.336-19.1,9.037-29.371c12.274-7.829,35.108-14.131,44.128-21.109,11.549,25.093-11.912,34.728-34,42.2C377.165,1012.2,376.331,1013.634,376.331,1013.634Z",
    transform: "translate(-87.444 -800.377)",
    fill: "#50a634",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M329.225,1002.522s-8.341-19.1,9.031-29.37c12.279-7.83,35.108-14.125,44.127-21.11,11.549,25.1-11.911,34.728-33.992,42.2C330.058,1001.085,329.225,1002.522,329.225,1002.522Z",
    transform: "translate(-311.156 -853.141)",
    fill: "#50a634",
    opacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilewavybg);
export default __webpack_public_path__ + "static/media/mobilewavybg.3e6c858525ca6f76884f62851db5e6d4.svg";
export { ForwardRef as ReactComponent };